var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.checkDate() == true)?_c('div',[_c('h2',{staticClass:"success--text"},[_vm._v(_vm._s(_vm.$t('weather.slurrySpreadingPeriod.open')))])]):_vm._e(),(_vm.checkDate() == false)?_c('div',[_c('h2',{attrs:{"color":"error"}},[_vm._v(_vm._s(_vm.$t('weather.slurrySpreadingPeriod.closed')))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }